<template>
    <div>
        <NavBar />
        <h1>Not Found</h1>
    </div>
</template>

<script>
import NavBar from '../components/nav-bar.vue';

export default {
    name: 'NotFound',
    components: {
        NavBar,
    },
};
</script>
